var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import "../styles/Accordion.css";
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
;
function Accordion(_a) {
    var title = _a.title, children = _a.children, name = _a.name, step = _a.step, isOpen = _a.isOpen, onToggle = _a.onToggle, isValid = _a.isValid;
    var id = "".concat(name, "-").concat(title.replace(/\s+/g, "-").toLowerCase());
    return (_jsxs("div", __assign({ className: "accordion-step-item ".concat(isOpen ? "open" : "") }, { children: [_jsxs("button", __assign({ type: "button", className: "accordion-step-header", onClick: onToggle, "aria-expanded": isOpen, "aria-controls": id, id: "".concat(id, "-header") }, { children: [_jsx("div", __assign({ className: "accordion-step-badge ".concat(isValid ? "badge-valid" : "badge-invalid") }, { children: step })), _jsx("span", __assign({ className: "accordion-step-title" }, { children: title })), _jsxs("div", __assign({ className: "accordion-step-icons" }, { children: [_jsx(KeyboardArrowDownIcon, { className: "icon-down" }), _jsx(KeyboardArrowUpIcon, { className: "icon-up" })] }))] })), _jsx("section", __assign({ className: "accordion-step-content", id: id, "aria-labelledby": "".concat(id, "-header"), style: { display: isOpen ? "block" : "none" } }, { children: children }))] })));
}
export default Accordion;
